export type McpServerType = 'contentful';

export enum McpServerStatus {
  Starting = 'starting',
  Running = 'running',
  Closing = 'closing',
  Restarting = 'restarting',
  Failed = 'failed',
}

export interface AdminMcpServer {
  id: string;
  type: McpServerType;
  userId: string;
  email: string | null;
  status: McpServerStatus;
  pid: number | null;
  startedAt: string;
  error: string | null;
}
